export default function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <header
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8"
      data-testid={testid}
    >
      <div className="max-w-2xl">
        {eyebrow && <div className="overline mb-3">{eyebrow}</div>}
        {/* CTDS 2.6 · Seitenüberschrift 32 px, weight 600 */}
        <h1 className="font-heading text-[28px] md:text-[32px] leading-[1.15] tracking-tight text-foreground">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-sm md:text-[14px] text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
    </header>
  );
}
